const indexItems = [
  { icon: 'ri-heart-line', title: '恋爱漫画', desc: '甜蜜浪漫 · 韩漫恋爱天花板', count: '8,560部', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-fire-line', title: '热血漫画', desc: '燃爆全场 · 日漫经典战斗', count: '5,430部', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-magic-line', title: '奇幻漫画', desc: '异世界冒险 · 魔法与剑', count: '4,210部', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-ghost-line', title: '悬疑漫画', desc: '烧脑推理 · 层层反转', count: '2,890部', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-building-line', title: '都市漫画', desc: '职场人生 · 现实共鸣', count: '3,670部', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-sword-line', title: '武侠漫画', desc: '古风江湖 · 侠义恩仇', count: '2,340部', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-planet-line', title: '科幻漫画', desc: '未来世界 · 星际探索', count: '1,980部', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">类型大全</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            皮皮漫画国漫类型大全 — 七大类型全面覆盖，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.slice(0, 4).map((item) => (
            <a
              key={item.title}
              href="#"
              className="group bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex items-start gap-4"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                <span className="text-xs text-foreground-400 mt-1.5 block">{item.count}</span>
              </div>
            </a>
          ))}

          <div className="sm:col-span-2 lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {indexItems.slice(4, 7).map((item) => (
              <a
                key={item.title}
                href="#"
                className="group bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex items-center gap-4"
              >
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300 ${item.color}`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm md:text-base text-foreground-950 whitespace-nowrap">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                  <span className="text-xs text-foreground-400 mt-1.5 block">{item.count}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}